import { LOCAL_STORAGE_KEYS } from "./AppEnumerations";
import { clearFileUrlCache } from "./SignedFileUrlCache";

export const localStorageUtils = {
  getAccessToken: () => {
    try {
      return localStorage.getItem(LOCAL_STORAGE_KEYS.AccessToken);
    } catch (e) {
      return null;
    }
  },
  setAccessToken: (token: string) => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEYS.AccessToken, token);
      return 1;
    } catch (e) {
      return 0;
    }
  },
  getRefreshToken: async () => {
    try {
      return await localStorage.getItem(LOCAL_STORAGE_KEYS.RefreshToken);
    } catch (e) {
      return null;
    }
  },
  setRefreshToken: (token: string) => {
    try {
      localStorage.setItem(LOCAL_STORAGE_KEYS.RefreshToken, token);
      return 1;
    } catch (e) {
      return 0;
    }
  },
  removeAll: async () => {
    try {
      await Promise.all([
        localStorage.removeItem(LOCAL_STORAGE_KEYS.AccessToken),
        localStorage.removeItem(LOCAL_STORAGE_KEYS.UserInfo),
      ]);
      clearFileUrlCache();
      return 1;
    } catch (e) {
      return 0;
    }
  },
  removeAccessToken: () => {
    try {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.AccessToken);
      clearFileUrlCache();
      return 1;
    } catch (e) {
      return 0;
    }
  },
  removeRefreshToken: () => {
    try {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.RefreshToken);
      return 1;
    } catch (e) {
      return 0;
    }
  },
};
